import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../AuthContext";
import { useI18n } from "../I18nContext";
import { formatApiErrorDetail } from "../api";
import PasswordInput from "../PasswordInput";

export default function Login() {
  const { t, lang, setLang } = useI18n();
  const { login } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const nextPath = params.get("next") || "/app";
  const [email, setEmail] = useState(params.get("email") || "");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const u = await login(email.trim(), password);
      if (u.lang) setLang(u.lang);
      navigate(nextPath);
    } catch (e2) {
      setErr(formatApiErrorDetail(e2.response?.data?.detail) || e2.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="tb-app tb-auth-page">
      <Link to="/" className="tb-app-logo" data-testid="auth-logo">
        Traction<span>Board</span>
      </Link>
      <form className="tb-form" onSubmit={submit} data-testid="login-form">
        <h1 className="tb-h1" style={{ marginBottom: "0.5rem", fontSize: "1.4rem" }}>
          {t("auth.loginTitle")}
        </h1>
        <div>
          <label>{t("auth.email")}</label>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="login-email"
            autoComplete="email"
          />
        </div>
        <div>
          <label>{t("auth.password")}</label>
          <PasswordInput
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            testid="login-password"
            autoComplete="current-password"
          />
        </div>
        {err && <div className="tb-form-error" data-testid="login-error">{err}</div>}
        <button type="submit" className="tb-primary-btn" disabled={loading} data-testid="login-submit">
          {loading ? t("auth.loading") : t("auth.submitLogin")}
        </button>
        <div style={{ textAlign: "center", marginTop: "-4px" }}>
          <Link to="/forgot-password" data-testid="link-forgot" style={{ fontSize: "0.86rem", color: "var(--muted)" }}>
            {t("auth.forgotLink")}
          </Link>
        </div>
        <div className="tb-lang-pick" style={{ justifySelf: "center" }}>
          <button type="button" className={lang === "en" ? "on" : ""} onClick={() => setLang("en")}>EN</button>
          <button type="button" className={lang === "fr" ? "on" : ""} onClick={() => setLang("fr")}>FR</button>
        </div>
      </form>
      <div className="tb-auth-switch">
        <Link to="/register" data-testid="link-register">{t("auth.switchToRegister")}</Link>
      </div>
    </div>
  );
}
